<template>
  <div>
    <v-toolbar dark color="primary">
      <img @click="goMainPage" src="logo.png" href="/" alt height="60" width="185">
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn style="text-decoration: none;" flat to="/expedicionRapida" v-if="TengoConfiguracion && !tengoPermiso">{{$t('servicios.servicioRapido')}}</v-btn>
        <v-btn style="text-decoration: none;" flat to="/servicioscliente" v-if="tengoPermiso">{{$t('servicios.servicios')}}</v-btn>
        <v-btn style="text-decoration: none;" flat to="/servicios" v-if="!tengoPermiso">{{$t('servicios.servicios')}}</v-btn>
        <v-btn style="text-decoration: none;" flat to="/servicios/create" v-if="!tengoPermiso">{{$t('servicios.nuevoServicio')}}</v-btn>
        <v-btn style="text-decoration: none;" flat to="/direcciones" v-if="!tengoPermiso">{{$t('domicilios.domicilios')}}</v-btn>
        <v-btn style="text-decoration: none;" flat to="/documentos" v-if="!tengoPermiso">{{$t('manuales.manuales')}}</v-btn>
      </v-toolbar-items>
      <v-toolbar-items>
        <v-menu
          offset-y
          origin="center center"
          class="elelvation-1"
          :nudge-bottom="14"
          :close-on-content-click="false"
          transition="scale-transition" >
          <v-chip light flat slot="activator">
            <v-avatar>
              <v-icon>account_circle</v-icon>
            </v-avatar>
            <b>{{Login && Login.Username}}</b>
          </v-chip>
          <v-card class="elevation-0" min-width="300" v-if="Auth.Usuario">
            <v-card-title card dense color="primary" class="pb-0">
              <v-toolbar-title dark><b>{{Auth.Usuario.DOMICILIO.Nombre}}</b></v-toolbar-title>
            </v-card-title>
            <p class="pl-3">Cliente {{Auth.Usuario.DATOS.CLIENTE}}</p>
            <hr/>
            <v-card-text class="pt-0 pb-0">
              <p>{{Auth.Usuario.DOMICILIO.Direccion}}</p>
              <p>{{Auth.Usuario.DOMICILIO.CodigoPostal}} - {{Auth.Usuario.DOMICILIO.Poblacion}}</p>
              <p>{{Auth.Usuario.DOMICILIO.Telefono}}</p>
              <p><b>Oficina: </b>{{Auth.Usuario.DATOS.OFICINA}}</p>
              <p><b>Departamento: </b>{{Auth.Usuario.DATOS.DEPARTAMENTO}}</p>
            </v-card-text>
            <hr/>
            <v-select
              v-if="items.length>0"
              v-model="user"
              :items="items"
              @change="changeLogin"
              return-object
              item-text="Nombre"
              item-value="Password"
              label="Cuentas"
              class="px-3"
            ></v-select>
            <locale-changer class="pl-3 pr-3"/>
            <v-card-actions class="pa-0" v-if="PuedoEditarConfiguracion">
              <v-btn block flat class="secondary" to="/admin">
                <u>Admin</u>
              </v-btn>
            </v-card-actions>
            <v-card-actions v-if="!tengoPermiso" class="pa-0">
              <v-btn block flat class="secondary" @click="dialogChangePassword=true">
                <u>{{$t('login.cambiarContraseña')}}</u>
              </v-btn>
            </v-card-actions>
            <v-card-actions class="pa-0">
              <v-btn block flat class="primary" @click="_logout()">{{$t('login.cerrarSesion')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-toolbar-items>

      <!-- Smartphone -->
      <v-menu class="hidden-md-and-up">
        <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
          <v-list>
            <v-list-tile-content><v-list-tile to="/expedicionRapida" v-if="TengoConfiguracion">{{$t('servicios.servicioRapido')}}</v-list-tile></v-list-tile-content>
            <v-list-tile-content><v-list-tile to="/servicios">{{$t('servicios.servicios')}}</v-list-tile></v-list-tile-content>
            <v-list-tile-content><v-list-tile to="/servicios/create">{{$t('servicios.nuevoServicio')}}</v-list-tile></v-list-tile-content>
            <v-list-tile-content><v-list-tile to="/direcciones">{{$t('domicilios.domicilios')}}</v-list-tile></v-list-tile-content>
            <v-list-tile-content><v-list-tile to="/documentos">{{$t('manuales.manuales')}}</v-list-tile></v-list-tile-content>
          </v-list>
      </v-menu>
    </v-toolbar>

    <v-dialog v-model="dialogChangePassword" width="400px">
      <change-password @cerrar="dialogChangePassword=false"/>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import ChangePassword from "./../components/ChangePassword";
import localeChanger from '@/components/locale-changer.vue';

export default {
  name: "navigation",
  components: { ChangePassword, localeChanger },
  created() {
    this.checkToken();
    if(this.usuarioActual && this.usuariosPermitidos.indexOf(this.usuarioActual)!==-1){
      this.tengoPermiso = true;
    }else this.tengoPermiso = false;
    this.user = this.$store.state.Auth.Login;
    this.items = this.$store.state.Auth.Usuarios;
  },
  updated(){
    if(this.usuarioActual && this.usuariosPermitidos.indexOf(this.usuarioActual)!==-1){
      this.tengoPermiso = true;
    }else this.tengoPermiso = false;
  },
  data() {
    return {
      dialogChangePassword: false,
      usuarioActual: this.$store.state.Auth.Login ? this.$store.state.Auth.Login.Username : null,
      usuariosPermitidos: ["Querol001", "Querol002", "Querol003", "Querol005", "Querol006", "Querol007", "Querol008", "Querol009", "Querol011", "Querol012", "Querol013", "Querol014", "Querol015", "Querol018", "Querol021", "Querol025", "Querol026", "Querol028", "Querol032", "Querol033", "Querol034", "Querol035", "Querol037", "Querol039", "Querol040", "Querol045", "Querol046", "Querol047", "Querol048", "Querol061", "Querol062", "Querol063", "Querol064", "Querol066", "Querol067", "Querol080"],
      tengoPermiso: false,
      items: null,
      user: null,
    };
  },
  methods: {
    ...mapMutations("Auth", ["logout"]),
    ...mapActions("Auth", ["logOut", "signIn"]),
    async changeLogin(){
      await this.logOut(this.Login);
      let ok = await this.signIn(this.user);
      if(ok){
        console.log("BIEN");
      }
    },
    async _logout() {
      await this.logOut(this.Login);
      this.$router.push("/login");
    },
    goMainPage() {
      this.$router.push("/servicios");
    },
    checkToken() {
      if (!this.EsLogged) return;

      fetch(this.$apiRoute + "token", {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("_token")
        }
      })
        .then(res => {
          return res.json();
        })
        .then(res => {
          if (!res.TokenValid) {
            this._logout();
          }
        })
        .catch(() => {
          // catch
          console.log("Request failed");
          this._logout();
        });
    }
  },
  computed: {
    ...mapGetters({
      EsLogged: "Auth/Logged",
      Login: "Auth/Login",
      TengoConfiguracion: "Auth/TengoConfiguracion",
      PuedoEditarConfiguracion: "Auth/PuedoEditarConfiguracion",
    }),
    ...mapState(["Auth"])
  }
};
</script>
